module.exports = __webpack_public_path__ + "img/ico_downloadform.588f137e.svg";